import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { Entrance, EntrancePostTarget } from '../../model/entrance';
import { AutoCompleteSelectionItem, IAutoCompleteService } from '../../../core/component/autocomplete-remote/autocomplete-remote.component';
import { catchError, finalize, map } from 'rxjs/operators';
import { IPostTargetLoader } from '../base/post-target-loader.interface';

@Injectable()
export class EntranceService extends DataService<Entrance> implements IAutoCompleteService, IPostTargetLoader<EntrancePostTarget> {
  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    private _messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(client, config, _messageService, Entrance, progressBar, 'entrance');
  }

  protected createModel(modelData: any): Entrance {
    try {
      return new Entrance(modelData);
    } catch (e) {
      console.log(e);
      throw new Error('Invalid data format.');
    }
  }

  getSelectionItem(id: string): Observable<AutoCompleteSelectionItem> {
    return this.client.get<any>(`${this.endpoint}/selectionItem/${id}`).pipe(
      map(item => new AutoCompleteSelectionItem(item.name, item.id, item, item.shortName)),
      catchError(e => {
        this._messageService.showError(e);
        return [];
      })
    );
  }

  getSelection(filter: string, options?: any, page?: number): Observable<AutoCompleteSelectionItem[]> {
    let queryArgs = {
      filter: filter,
      maxItems: 20,
    };
    if (options) queryArgs['options'] = options;
    if (page && page > 0) queryArgs['page'] = page;

    return this.client.post<any[]>(`${this.endpoint}/selection`, queryArgs).pipe(
      map(data => data.map(item => new AutoCompleteSelectionItem(item.name, item.id, item, item.shortName))),
      catchError(e => {
        this._messageService.showError(e);
        return [];
      })
    );
  }

  getFilteredAutocompleteList(filter: any): Observable<EntrancePostTarget[]> {
    filter = this.prepareFilter(filter);

    this.progressBar.start();
    return this.client.post<EntrancePostTarget>(`${this.endpoint}/filter`, JSON.stringify(filter)).pipe(
      map(items => {
        if (Array.isArray(items)) {
          return items.map(m => new EntrancePostTarget(m));
        }
        return [];
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  getPostTargetModels(buildingId: string): Observable<EntrancePostTarget[]> {
    this.progressBar.start();
    return this.client.get<EntrancePostTarget[]>(`${this.endpoint}/post-target/${buildingId}`).pipe(
      map(response => response.map(x => new EntrancePostTarget(x))),
      finalize(() => this.progressBar.stop())
    );
  }
}
